import { Component, Injectable, Input } from '@angular/core';
import { Stormpath } from '../stormpath/stormpath.service';
export var ResendEmailVerificationComponent = (function () {
    function ResendEmailVerificationComponent(stormpath) {
        this.stormpath = stormpath;
    }
    ResendEmailVerificationComponent.prototype.ngOnInit = function () {
        this.posting = false;
        this.sent = false;
        this.formModel = {
            login: ''
        };
    };
    ResendEmailVerificationComponent.prototype.send = function () {
        var _this = this;
        this.posting = true;
        this.stormpath.resendVerificationEmail(this.formModel)
            .subscribe(function () {
            _this.posting = false;
            _this.sent = true;
        }, function (error) {
            _this.posting = false;
            _this.error = error.message;
        });
    };
    ResendEmailVerificationComponent.prototype.onSubmit = function () {
        this.send();
    };
    ResendEmailVerificationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'resend-email-verification',
                    template: "<template #defaultTemplate>\n<div class=\"row\">\n  <div class=\"col-sm-offset-4 col-xs-12 col-sm-4\">\n\n    <p *ngIf=\"sent\" class=\"alert alert-success\">\n      We have sent a new verification message to your email address, please check your email for this message.\n    </p>\n\n    <p class=\"text-danger\" *ngIf=\"error\">{{error}}</p>\n  </div>\n</div>\n\n<div class=\"row\">\n  <div class=\"col-xs-12\">\n    <form class=\"form-horizontal\" *ngIf=\"!sent\" (ngSubmit)=\"onSubmit()\" autocomplete=\"off\">\n\n      <div class=\"form-group\">\n        <label for=\"spUsername\" class=\"col-xs-12 col-sm-4 control-label\">Email address</label>\n        <div class=\"col-xs-12 col-sm-4\">\n          <input class=\"form-control\" id=\"spUsername\" [(ngModel)]=\"formModel.login\" [disabled]=\"posting\">\n        </div>\n      </div>\n      <div class=\"form-group\">\n        <div class=\"col-sm-offset-4 col-xs-12\">\n          <p class=\"text-danger\" *ngIf=\"error\">{{error}}</p>\n          <button type=\"submit\" class=\"btn btn-primary\" [disabled]=\"posting\">Re-Send Verification</button>\n        </div>\n      </div>\n    </form>\n  </div>\n</div>\n</template>\n<template\n  [ngTemplateOutlet]=\"customTemplate || defaultTemplate\">\n</template>"
                },] },
        { type: Injectable },
    ];
    /** @nocollapse */
    ResendEmailVerificationComponent.ctorParameters = function () { return [
        { type: Stormpath, },
    ]; };
    ResendEmailVerificationComponent.propDecorators = {
        'customTemplate': [{ type: Input },],
    };
    return ResendEmailVerificationComponent;
}());
//# sourceMappingURL=resend-email-verification.component.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-stormpath/dist/esm/src/resend-email-verification/resend-email-verification.component.js
// module id = 571
// module chunks = 0